import { render, staticRenderFns } from "./ManagerCommisionTable.vue?vue&type=template&id=33ad751b&"
import script from "./ManagerCommisionTable.vue?vue&type=script&lang=js&"
export * from "./ManagerCommisionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports